import React, { useEffect, useState, useCallback } from "react";
import Nav from "@/components/landing/Nav";
import Hero from "@/components/landing/Hero";
import Gallery from "@/components/landing/Gallery";
import ArtistStory from "@/components/landing/ArtistStory";
import Patronage from "@/components/landing/Patronage";
import TrustSection from "@/components/landing/TrustSection";
import Footer from "@/components/landing/Footer";
import ReservationDialog from "@/components/ReservationDialog";
import { api } from "@/lib/api";
import { trackPageView } from "@/lib/analytics";

export default function Landing() {
  const [artworks, setArtworks] = useState([]);
  const [reserveOpen, setReserveOpen] = useState(false);
  const [reserveArt, setReserveArt] = useState(null);

  useEffect(() => {
    trackPageView();
    api
      .get("/artworks")
      .then((r) => setArtworks(r.data || []))
      .catch(() => setArtworks([]));
  }, []);

  const openReserve = useCallback((art) => {
    setReserveArt(art || null);
    setReserveOpen(true);
  }, []);

  return (
    <div className="min-h-screen bg-[var(--ivory)]">
      <Nav onReserveClick={() => openReserve(artworks[0])} />
      <Hero onReserve={() => openReserve(artworks[0])} />
      <Gallery artworks={artworks} onReserve={openReserve} />
      <ArtistStory />
      <Patronage />
      <TrustSection />
      <Footer />

      <ReservationDialog
        open={reserveOpen}
        artwork={reserveArt}
        artworks={artworks}
        onClose={() => setReserveOpen(false)}
      />
    </div>
  );
}
